export const EMPLOYMENT_TYPE_LABELS = {
	fullTime: 'Full-time',
	partTime: 'Part-time',
};

export const HOME_BASE_TYPE_LABELS = {
	permanent: 'Permanent',
	temporary: 'Temporary',
};

export const CREW_LOG_ENTRY_TEXT = {
	effectiveFrom: 'Effective from:',
	replacingDriver: 'Replacing driver:',
	absenceType: 'Type:',
	personalInfoMap: {
		phone: { text: 'Phone' },
		startTime: { text: 'Start time' },
		endTime: { text: 'End time' },
		medicalCheckExpiresAt: { text: 'Medical check expiration date' },
		driverLicenseExpiresAt: { text: 'Driver license expiration date' },
		drugTestExpiresAt: { text: 'Drug test expiration date' },
		driverCard: { text: 'Driver card' },
		offDayAvailableForAssignments: { text: 'Off day available for assignments' },
		license: { text: 'License' },
		email: { text: 'Email' },
	},
	eligibilityRuleName: {
		isActive: 'Crew member is not active',
		hasCorrectRole: 'Crew member does not have the correct role',
		notEnded: "Crew member's end date is before the end of the work assignment",
		medicalCheckIsValid: "Crew member's medical check is not valid",
		drugTestIsValid: "Crew member's drug test is not valid",
		driverLicenseIsValid: "Crew member's driver license is not valid",
		driverCardIsValid: "Crew member's driver card is not valid",
		matchingMobilityPartner:
			"Crew member's partnership not matching with assigned vehicle mobility partner",
		hasHomebase: 'Crew member does not have a home base specified',
		hasNoAbsences: 'Crew member has absences during the work assignment',
		hasNoWorkAssignments: 'Crew member has overlapping work assignments',
		hasNoInterferingWorkAssignments:
			"This work assignment interferes with crew member's next assignments",
		presentInDepartureLocation: 'Crew member is not expected to be at the departure location',
		hasEmploymentType: "Crew member doesn't have employment type",
	},
};
